import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getLoadingMaskReducer } from 'reducer/common/loadingCount';
import { isUndefined } from 'tradevan-ui/consts';

interface LoadingMaskProps {
  top?: string | number;
  show?: boolean;
}
/** 讀取中的遮罩 */
const LoadingMask = (props: LoadingMaskProps) => {
  const { top, show } = props;
  const [scrollY, setScrollY] = useState(window.scrollY);
  const loadingMaskObj = useSelector(getLoadingMaskReducer);
  const updateScroll = () => {
    setScrollY(window.scrollY);
  };

  const getDisplay = () => {
    if (!isUndefined(show)) {
      return show ? 'flex' : 'none';
    }
    return loadingMaskObj.show && loadingMaskObj.count > 0 ? 'flex' : 'none';
  };

  useEffect(() => {
    window.addEventListener('scroll', updateScroll);
    return () => window.removeEventListener('scroll', updateScroll);
  }, []);

  return (
    <div
      style={{
        display: getDisplay(),
        /** table會用到show 他需要100%  */
        height: show ? '100%' : `calc( 100vh + ${scrollY + 50}px )`,
        position: 'absolute',
        zIndex: '4000',
        width: '100%',
        left: '0',
        top: '0',
        backgroundColor: 'rgb(0 0 0 / 30%)',
      }}
    >
      <Spinner
        style={{
          width: '2.5rem',
          height: '2.5rem',
          position: 'absolute',
          left: '50%',
          /** 有top吃TOP  */
          top: top || window.innerHeight / 2 + scrollY,
        }}
        animation="border"
        variant="primary"
      />
    </div>
  );
};

export default LoadingMask;
